<template>
  <div class="Productstable-div">
    <div class="Productstable-th">
      <div class="Productstable-td Productstable-td1">产品型号</div>
      <div class="Productstable-td Productstable-td2">CPU核</div>
      <div class="Productstable-td Productstable-td3">工艺特征</div>
      <div class="Productstable-td Productstable-td4">产品特征</div>
      <div class="Productstable-td Productstable-td5">ROM容量</div>
      <div class="Productstable-td Productstable-td6">RAM容量</div>
      <div class="Productstable-td Productstable-td7">封装脚位数</div>
    </div>
    <div class="Productstable-tbody">
      <!-- <div class="Productstable-tbody-tr"
           v-for="(item, index) in tablelist" :key="index">
        <div class="Productstable-td Productstable-td1">
          <input type="checkbox" />
          {{item.vsion}}
        </div>
        <div class="Productstable-td Productstable-td2">
          <input type="checkbox" />
          {{item.value1}}
        </div>
        <div class="Productstable-td Productstable-td3">
          <input type="checkbox" />
          {{item.value2}}
        </div>
        <div class="Productstable-td Productstable-td4">
          <input type="checkbox" />
          {{item.value3}}
        </div>
        <div class="Productstable-td Productstable-td5">
          <input type="checkbox" />
          {{item.value4}}
        </div>
        <div class="Productstable-td Productstable-td6">
          <input type="checkbox" />
          {{item.value5}}
        </div>
        <div class="Productstable-td Productstable-td7">
          <input type="checkbox" />
          {{item.value6}}
        </div>
      </div> -->
      <div class="Productstable-tbody-tr">
        <template v-for="(item, index) in conditionArr">
          <div
            :class="`Productstable-td Productstable-td${index+1}`"
            :key="index"
          >
            <div
              v-for="(itemData, itemDataIndex) in item.data"
              :key="itemDataIndex"
              v-if="index > 0"
            >
              <input
                type="checkbox"
                v-model="itemData.value"
                @change="changeCheckBox"
              />{{ itemData.name }}
            </div>
          </div>
        </template>
        
        <!-- <div class="Productstable-td Productstable-td2">
          <input type="checkbox" />
          {{item.value1}}
        </div>
        <div class="Productstable-td Productstable-td3">
          <input type="checkbox" />
          {{item.value2}}
        </div>
        <div class="Productstable-td Productstable-td4">
          <input type="checkbox" />
          {{item.value3}}
        </div>
        <div class="Productstable-td Productstable-td5">
          <input type="checkbox" />
          {{item.value4}}
        </div>
        <div class="Productstable-td Productstable-td6">
          <input type="checkbox" />
          {{item.value5}}
        </div>
        <div class="Productstable-td Productstable-td7">
          <input type="checkbox" />
          {{item.value6}}
        </div> -->
      </div>
      <div
        class="Productstable-tbody-tr"
        v-for="(item, index) in data"
        :key="index"
        @click="link(item)"
        style="cursor: pointer;"
      >
        <template v-if="checkProductCondition(item)">
          <div class="Productstable-td Productstable-td1">
            {{ item.cpxh }}
          </div>
          <div class="Productstable-td Productstable-td2">
            {{ item.cpuh }}
          </div>
          <div class="Productstable-td Productstable-td3">
            {{ item.gytz }}
          </div>
          <div class="Productstable-td Productstable-td4">
            {{ item.cptz }}
          </div>
          <div class="Productstable-td Productstable-td5">
            {{ item.ccqCxccq }}
          </div>
          <div class="Productstable-td Productstable-td6">
            {{ item.ccqSjccq }}
          </div>
          <div class="Productstable-td Productstable-td7">
            {{ item.fzxs }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { conditionArr } from "@/common/condition";
export default {
  name: "Productstable",
  props: {
    data: {
      type: Array,
      default: [],
    },
    searchValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      conditionArr,
      productConditionArr: [],
      tablelist: [
        {
          vsion: "Rb33P165A",
          value1: "32bit",
          value2: "32bit",
          value3: "32bit",
          value4: "32bit",
          value5: "32bit",
          value6: "32bit",
          value7: "32bit",
          value8: "32bit",
          value9: "32bit",
        },
      ],
    };
  },
  watch: {
    searchValue(newVal, oldVal) {
      console.log(newVal)
      this.searchValue = newVal
    },
    $route() {
      if(this.$route.query.type !== undefined) {
        this.conditionArr[0].data.forEach((v, i) => {
            v.value = i == this.$route.query.type
        })
        this.changeCheckBox()
      }
      // console.log(this.$route.query.type)
    }
  },
  mounted() {
      if(this.$route.query.type !== undefined) {
        this.conditionArr[0].data.forEach((v, i) => {
            v.value = i == this.$route.query.type
        })
        this.changeCheckBox()
      }
  },
  methods: {
    changeCheckBox() {
      this.productConditionArr = this.conditionArr
        .map((item) => {
          let arr = [];
          for (let i = 0; i < item.data.length; i++) {
            if (item.data[i].value) {
              arr.push(i + 1);
            }
          }
          return arr;
        });
    },
    checkProductCondition(item) {
      let productCondition = item.productCondition
      let itemProductConditionArr = productCondition.split('_').map(item => item.split(','))
      console.log(this.productConditionArr, itemProductConditionArr)
      
      let res = true
      for(let i = 0; i < itemProductConditionArr.length; i++) {
        let flag = false
        if(this.productConditionArr[i]) {
          if (this.productConditionArr[i].length > 0) {
            for(let j = 0; j < itemProductConditionArr[i].length; j++) {
              flag = flag || this.productConditionArr[i].includes(Number(itemProductConditionArr[i][j]))
            }
          } else {
            flag = true
          }
        } else {
          flag = true
        }
        res = res && flag
      }

      if(this.searchValue) {
        res = res && item.cpxh.indexOf(this.searchValue) != -1
      }

      return res
    },
    gourl(url) {
      window.location.href = url;
    },
    link(item) {
      this.$router.push(`/Products?id=${item.id}&name=${item.cpxh}`);
    },
  },
};
</script>

<style scoped>
.Productstable-div {
  width: fit-content;
}

.Productstable-th {
  background-color: #f5f5f5;
  color: #262626;
  font-weight: bold;
  font-size: 14px;
  display: flex;
}

.Productstable-th .Productstable-td {
  background-color: #f5f5f5;
}

.Productstable-td {
  margin: 15px 10px;
  border-left: 1px solid #ccc;
  padding-left: 15px;
}

.Productstable-td:first-child,
.Productstable-tbody-tr .Productstable-td {
  border: none;
}

.Productstable-td {
  width: 150px;
}
.Productstable-td1 {
  width: 80px;
}
.Productstable-td2 {
  width: 65px;
}
.Productstable-td5 {
  width: 130px;
}
.Productstable-td6 {
  width: 65px;
}

.Productstable-tbody-tr {
  display: flex;
  box-sizing: border-box;
  font-size: 14px;
  color: #4c4c4c;
  border-bottom: 1px solid #f5f5f5;
}
</style>